const disciplineCategories = {
  UnSet: 0,
  ValidForPEI: 1,
  ValidForPEIOther: 2,
  ValidForRemedioProvional: 3,
  ValidForEncuentro: 4,
  ValidForAppointment: 5,
  ValidForTriannual: 6,
  ValidForRegistry: 7,
  ValidForTherapy: 8,
};

export default disciplineCategories;
